import { s, tableTokens } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const dataGridChromeSx: SxProps<Theme> = {
  '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
    px: s(tableTokens.cellPadding.x),
    py: s(tableTokens.cellPadding.y),
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-columnHeaderDraggableContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    paddingLeft: s('xxs'),
    paddingRight: s('xxs'),
  },
  '& .MuiDataGrid-cellContent': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: (theme) => `calc(${theme.app.density.dataGrid.headerHeight}px - ${s('xs')})`,
    height: 'auto',
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: s('none'),
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  '& .MuiTablePagination-toolbar': {
    minHeight: (theme) => `calc(${theme.app.density.dataGrid.headerHeight}px - ${s('xs')})`,
    height: 'auto',
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'hidden',
  },
  '& .MuiTablePagination-actions': {
    marginLeft: s('sm'),
    gap: 0,
  },
  '& .MuiTablePagination-actions .MuiIconButton-root': {
    margin: 0,
    minWidth: s('2xl'),
    width: s('2xl'),
    height: s('2xl'),
    padding: s('none'),
  },
};
